import { ComponentHeader, StyledCreate } from "@components";

import { GenerateCouponForm } from "@modules";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

export const PageGenerateCoupon = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setLoading(true));
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 1000);
  }, []);

  return (
    <>
      <ComponentHeader title={t("page.generate_coupon")} />
      <StyledCreate>
        <GenerateCouponForm />
      </StyledCreate>
    </>
  );
};
